<template>
  <div class="animated fadeIn">

    <b-card-body>
      <b-row>
        <b-col sm xs="12" class="text-left mt-3" v-if="can('agence-create')">
          <router-link to="/theme/agences/create/entite/null">
            <b-button variant="primary" style="width:103px;height:40px;border-radius:0px;">
              <i class="fa fa-plus"></i>&nbsp;Nouveau
            </b-button>
          </router-link>
        </b-col>
      </b-row>
    </b-card-body>
    <b-row>
     <b-col lg="12">
        <!--<c-table-entities striped caption="<i class='fa fa-align-justify'></i> Liste des entités"></c-table-entities>-->
          <div>
              <vue-good-table styleClass="vgt-table condensed bordered striped" :columns="columns" :rows="rows" :fixed-header="false" :pagination-options="pagination" :search-options="search" @on-sort-change="onSortChange" @on-column-filter="onColumnFilter">
                <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'btn'" style="font-size: 0.875rem;">
                        
                          <b-dropdown id="ddown-sm-split" size="sm" text="Plus de détails" class="m-2">
                            <div role="group" aria-lableledby="header1">                   
                                <router-link :to="'agences/edit/' + props.row.id" v-if="can('agence-edit')"><b-dropdown-item-button aria-describedby="header1" :id="props.row.id"><i class="fa fa-edit"></i> Modifier</b-dropdown-item-button></router-link>
                                <!-- <b-dropdown-item-button aria-describedby="header1" v-if="can('agence-delete')" @click.prevent="confirm()"><i class="fa fa-trash"></i> Supprimer</b-dropdown-item-button>
                                <router-link :to="'agences/show/' + props.row.id" v-if="can('agence-show')"><b-dropdown-item-button aria-describedby="header1"><i class="fa fa-eye"></i> Plus d'infos</b-dropdown-item-button></router-link> -->
                            </div>
                            <div role="group" aria-lableledby="header2">
                              <b-dropdown-header id="header2">Autres actions ...</b-dropdown-header>
                              <router-link :to="'/historique/agence/'+ props.row.id">
                                <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-users"></i> Historique des activités</b-dropdown-item-button>
                              </router-link>
                              <router-link :to="'/guichets/create/agence/' + props.row.id" v-if="can('guichet-create')">
                                <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-money"></i> Guichets</b-dropdown-item-button>
                              </router-link>
                              <router-link :to="'/transferts/list/agence/' + props.row.id" v-if="can('operation-list-by-agence')">
                                <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-money"></i> Opérations</b-dropdown-item-button>
                              </router-link>
                              <!--<b-dropdown-item-button aria-describedby="header2">Delete</b-dropdown-item-button>-->
                            </div>
                          </b-dropdown>
                          <b-modal ref="myModalRef" hide-footer centered title="Confirmation de la désativation">
                            <div class="d-block text-center">
                              <p style>Etes vous certain de vouloir désactiver cette agence ?</p>
                              <h5>Voulez-vous continuer ?</h5>
                            </div>
                            <b-btn class="mt-3 col-lg-6" variant="outline-danger"  @click="cancel_delete">Annuler</b-btn>
                            <b-btn class="mt-3 col-lg-6" variant="outline-success"  @click="post">Valider</b-btn>
                          </b-modal>
                    </span>
                    <span v-else style="font-size: 0.875rem;">
                      {{props.formattedRow[props.column.field]}}
                    </span>
                  </template>
              </vue-good-table>
          </div>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
//import cTableEntities from './TableEntities.vue'
import { VueGoodTable } from 'vue-good-table';
import { mapState, mapActions } from 'vuex';
export default {
  name: 'tables',
  //components: {cTableEntities},
  components: {VueGoodTable},
   data(){
    return {
      totalRecords :0,
      columns: [
        {
          label: 'Agence',
          field: 'nom_agence',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Ville',
          field: 'ville',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Commune',
          field: 'commune',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Entité',
          field: 'entite_nom',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },      
        {
          label: 'Telephone',
          field: 'telephone',
         // type: 'percentage',
          filterable: true,
          thClass: 'custom-th-class',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Enregistré',
          field: 'created_at',
          type: 'date',
          dateInputFormat: 'YYYY-MM-DD',
          dateOutputFormat: 'YYYY-MM-DD',
          formatFn: this.formatFn,
          filterable: true,
          thClass: 'custom-th-class',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Action',
          field: 'btn',
          html: true,
          width: '150px',
        }
      ],
      rows: [],
      pagination:{
          enabled: true,
          mode: 'pages',
          perPage: 10,
          position: 'bottom',
          perPageDropdown: [3,5, 10, 50,100],
          dropdownAllowAll: false,
          setCurrentPage: 1,
          nextLabel: 'Suivant',
          prevLabel: 'Précédent',
          rowsPerPageLabel: 'Lignes par page',
          ofLabel: 'de',
          pageLabel: 'page', // for 'pages' mode
          allLabel: 'All',
        },
        search:{
            enabled: false,
            trigger: 'keyup',
            placeholder: 'Rechercher dans la table',
        },
        serverParams: {
          nom_agence:'',
          ville:'',
          commune:'',
          entite_nom:'',
          telephone:'',
          created_at:'',
          entite_id:'',
          page:1,
          current_page: 1,
          nb_lines: 10
        },
        entite_id:''
    };
  },
  computed: mapState({
    agencies: state => state.agency.all
  }),
  created () {
    
    
  },
  methods:{
      formatFn: function (value) {
          return value != null ? value : null
      },
      hideModal () {
        this.$refs.myModalRef.hide()
      },
      async cancel_delete(){
        this.hideModal()
      },
      async confirm(){
        this.$refs.myModalRef.show()
      },
      async get_all_agencies(){
        this.entite_id = this.$route.params.entite_id
        console.log("mon agence id ",this.$route.params.entite_id)
        this.$store.dispatch('agency/get_all_agencies_by_entity',this.$route.params.entite_id).then(()=>{
            return this.rows =  store.getters['agency/rows'];
        })
      },
      can(perm){
          return store.getters['auth/can'](perm)
      },
      updateParams(newProps) {
        this.serverParams = Object.assign({}, this.serverParams, newProps);
      },
      onPageChange(params) {
        this.serverParams.page = params.currentPage
        this.updateParams({page: params.currentPage,current_page: params.currentPage});
        this.loadItems();
      },
      onPerPageChange(params) {
        this.serverParams.nb_lines = params.currentPerPage
        console.log(params)
        this.updateParams({page: params.currentPage,paginate:params.currentPerPage});
        this.loadItems();
      },
      onSortChange(params) {
        this.updateParams({
          sort: {
            type: params.sortType,
            field: this.columns[params.columnIndex].field,
          },
        });
        this.loadItems();
      },    
      onColumnFilter(params) {
        this.serverParams.nom_agence=params.columnFilters.nom_agence,
        this.serverParams.ville=params.columnFilters.ville,
        this.serverParams.commune=params.columnFilters.commune,
        this.serverParams.entite=params.columnFilters.entite,
        this.serverParams.telephone=params.columnFilters.telephone,
        this.serverParams.created_at=params.columnFilters.created_at,
        this.updateParams(params);
        this.loadItems();
      },
      // load items is what brings back the rows from server
      loadItems() {
        console.log('server params ',this.serverParams)
        this.serverParams.entite_id = this.$route.params.entite_id
        this.$store.dispatch('agency/get_all_agencies_by_entity',this.serverParams).then(()=>{
            return this.rows =  store.getters['agency/rows'];
        })
      }
  },
  mounted(){
    //this.get_all_agencies()
    this.loadItems();
  }
  
}
</script>
